import React from 'react';
import { 
  FaAmbulance, 
  FaFlask, 
  FaShieldAlt, 
  FaPiggyBank, 
  FaFileContract, 
  FaIdCard,
  FaCreditCard,
  FaEnvelope,
  FaLandmark,
  FaGavel,
  FaShoppingCart,
  FaPills,
  FaMoneyBillWave,
  FaFileInvoiceDollar,
  FaPhoneAlt,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaClock,
  FaUsers,
  FaStar
} from "react-icons/fa";
import { RiGovernmentLine } from "react-icons/ri";
import Layout from '../../../components/user/Layout';

const serviceContent = {
  "Ambulance": {
    icon: <FaAmbulance className="text-3xl text-red-500" />,
    description: "24/7 emergency ambulance services with trained medical staff and life-saving equipment",
    features: [
      "Emergency response within 15 minutes",
      "Fully equipped with ICU facilities",
      "Trained paramedical staff",
      "GPS tracked vehicles",
      "Insurance tie-ups for cashless service"
    ],
    contact: {
      phone: "108 / 102",
      email: "ambulance@service.com",
      hours: "24/7"
    },
    stats: {
      responseTime: "15 mins",
      coverage: "50+ cities",
      availability: "24/7"
    }
  },
  "Blood Test": {
    icon: <FaFlask className="text-3xl text-pink-500" />,
    description: "Comprehensive blood testing services at home or at our partnered labs with accurate results",
    features: [
      "Home sample collection available",
      "200+ test parameters",
      "Digital reports within 24 hours",
      "Certified phlebotomists",
      "Free follow-up consultation"
    ],
    tests: ["Complete Blood Count", "Lipid Profile", "Liver Function", "Thyroid Profile", "Diabetes Screening", "Vitamin Tests"],
    contact: {
      phone: "1800-123-4567",
      email: "labs@service.com",
      hours: "6 AM - 10 PM"
    }
  },
  "Insurance": {
    icon: <FaShieldAlt className="text-3xl text-blue-500" />,
    description: "Health, life, and vehicle insurance plans with comprehensive coverage and easy claim process",
    features: [
      "Health insurance with cashless hospitalization",
      "Life insurance with high coverage",
      "Vehicle insurance with quick claim settlement",
      "Family floater plans",
      "Pre-existing disease coverage"
    ],
    plans: ["Health Insurance", "Life Insurance", "Vehicle Insurance", "Travel Insurance", "Home Insurance"],
    contact: {
      phone: "1800-987-6543",
      email: "insurance@service.com",
      hours: "9 AM - 8 PM"
    }
  },
  "Bank Account": {
    icon: <FaPiggyBank className="text-3xl text-emerald-500" />,
    description: "Zero balance savings accounts with digital banking features and attractive interest rates",
    features: [
      "Zero balance requirement",
      "Free debit card with insurance",
      "Digital onboarding",
      "4% interest rate on savings",
      "Unlimited free transactions"
    ],
    documents: ["Aadhar Card", "PAN Card", "Passport size photo"],
    contact: {
      phone: "1800-456-7890",
      email: "banking@service.com",
      hours: "10 AM - 6 PM"
    }
  },
  "Pension": {
    icon: <FaFileContract className="text-3xl text-amber-500" />,
    description: "PF and ESIC pension services with online tracking, grievance redressal, and expert assistance",
    features: [
      "Online PF withdrawal assistance",
      "Pension calculation and application",
      "Grievance tracking system",
      "Document verification service",
      "Expert consultation"
    ],
    services: ["PF Withdrawal", "Pension Application", "ESIC Benefits", "Grievance Redressal", "Document Help"],
    contact: {
      phone: "1800-111-2222",
      email: "pension@service.com",
      hours: "9:30 AM - 5:30 PM"
    }
  },
  "ID card": {
    icon: <FaIdCard className="text-3xl text-purple-500" />,
    description: "Digital and physical ID cards with QR code verification and multi-purpose usage",
    features: [
      "Digital ID with QR code",
      "Physical card with hologram",
      "Multi-purpose identification",
      "Government recognized",
      "Easy renewal process"
    ],
    uses: ["Identity Proof", "Access to Services", "Discounts & Offers", "Verification Purposes"],
    contact: {
      phone: "1800-333-4444",
      email: "idcard@service.com",
      hours: "10 AM - 7 PM"
    }
  }
};

const ServicePage = ({ service }) => {
  const content = serviceContent[service] || {
    icon: <FaStar className="text-3xl text-blue-500" />,
    description: `Comprehensive ${service} services with professional support and easy access`,
    features: [
      "Professional service delivery",
      "24/7 customer support",
      "Easy application process",
      "Document assistance",
      "Quick resolution"
    ],
    contact: {
      phone: "1800-000-0000",
      email: "support@service.com",
      hours: "9 AM - 9 PM"
    }
  };

  return (
    <Layout>
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl p-6 md:p-8 text-white shadow-xl mb-8">
            <div className="flex flex-col md:flex-row items-center justify-between">
              <div className="flex items-center mb-6 md:mb-0">
                <div className="bg-white/20 p-4 rounded-xl mr-4">
                  {content.icon}
                </div>
                <div>
                  <h1 className="text-3xl md:text-4xl font-bold mb-2">{service} Service</h1>
                </div>
              </div>
             
             <div className="">
                Comming soon...
             </div>
            </div>
          </div>

        </div>
      </div>
    </Layout>
  );
};

export default ServicePage;